export default "__VITE_ASSET__D_FvPUw3__"